import styled from 'styled-components'

export const MarqueeStyle = styled.div`
/* 遮罩层 */
.update-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

/* 弹窗容器 */
.update-modal {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: modal-fade-in 0.3s ease-in-out;
}

@keyframes modal-fade-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 弹窗头部 */
.update-modal-header {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.update-modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1f2329;
}

.version-text {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #6e7681;
}

/* 弹窗内容 */
.update-modal-content {
  margin-bottom: 24px;
}

.error-tip {
  color: #ff4d4f;
  font-size: 14px;
  margin: 0;
}

.update-tips p {
  margin: 0 0 12px 0;
  font-size: 15px;
  color: #4e5969;
}

.update-log {
  background: #f7f8fa;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
}

.update-log span {
  font-weight: 500;
  color: #1f2329;
}

.update-log p {
  margin: 8px 0 0 0;
  color: #6e7681;
  line-height: 1.5;
}

.download-progress-wrap p {
  margin: 0 0 8px 0;
  font-size: 15px;
  color: #4e5969;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #1890ff;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.download-complete p {
  margin: 0 0 8px 0;
  font-size: 15px;
  color: #4e5969;
}

.download-complete p:first-child {
  color: #52c41a;
  font-weight: 500;
}

/* 弹窗底部按钮 */
.update-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-later {
  background: #f7f8fa;
  color: #4e5969;
}

.btn-later:hover {
  background: #f0f0f0;
}

.btn-primary {
  background: #1890ff;
  color: #ffffff;
}

.btn-primary:hover {
  background: #096dd9;
}

.btn-disabled {
  background: #cccccc;
  color: #ffffff;
  cursor: not-allowed;
}
`
